import React, {useState } from 'react';


import FormInput from '../FormInput'
import PageTitle from '../PageTitle'
import PageSubtitle from '../PageSubtitle'
import ButtonHover from '../ButtonHover'
// import FormSelect from './FormSelect'
// import PageSubtitle from './PageSubtitle'
import Header from '../Navbar'


function PrephysicianRegister (props){


const[userName, setUserName] = useState("");
const[email, setEmail] = useState("");
const[password1, setPassword1] = useState("");
const[password2, setPassword2] = useState("");
const[errorUserName, setErrorUserName] = useState("")
const[errorEmail, setErrorEmail] = useState("")
const[errorPassword1, setErrorPassword1] = useState("")
const[errorPassword2, setErrorPassword2] = useState("")
const[errorPasswordLength, setErrorPasswordLength] = useState("")
const[errorPasswordMatch, setErrorPasswordMatch] = useState("")
const[showErrors, setShowErrors] = useState(false)

const onSubmitUser = async(e) => {
  e.preventDefault();

  let validationUserName = (!userName)
    ? setErrorUserName("* Please enter username")
    : setErrorUserName("")

  let validationEmail = (!email)
    ? setErrorEmail("* Please enter email")
    : setErrorEmail("")

  let validationPassword = (!password1)
    ? setErrorPassword1("* Please enter password")
    : setErrorPassword1("")

  let validationPassword2 = (!password2)
    ? setErrorPassword2("* Please enter password confirmation")
    : setErrorPassword2("")

  let validationPasswordLength = (password1.length < 6)
    ? setErrorPasswordLength("* Password must have at least 6 characters")
    : setErrorPasswordLength("")

  let validationPasswordMatch = (password1 !== password2)
    ? setErrorPasswordMatch("* Passwords do not match")
    : setErrorPasswordMatch("")

  if (!userName || !email || !password1 || !password2 || password1.length < 6 || password1 !== password2) {


    setShowErrors(true)

  } else {


    try {
      const dateVar = new Date();
      const dateJoined = (((dateVar.getMonth() > 8) ? (dateVar.getMonth() + 1) : ('0' + (dateVar.getMonth() + 1))) + '/' + ((dateVar.getDate() > 9) ? dateVar.getDate() : ('0' + dateVar.getDate())) + '/' + dateVar.getFullYear());

      const body = {userName, email, password1, password2, dateJoined};
      await fetch("http://localhost:3001/users/register", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      });

      window.location = "/prephysicianform";

    } catch (err) {
      console.error(err.message)
    }
  }

}



let warnStyle ={
  color: '#292929',
  fontSize: '17px',
  margin: '3px 0 0 0',
  fontFamily: 'Montserrat',
  fontWeight: '600',
  color: 'white',
}

    return(
      <div>
        <div style={{display: 'flex'}}>
          <div style={{
              width: '7vw',
              height: '84vh'
            }}>
          </div>
          <div style={{width: '86vw'}}>
            <Header/>
            <div style={{height: '50px'}}></div>
            <PageTitle
              pageTitle="Let's make this secure"/>
            <PageSubtitle
              pageSubtitle = 'Enter your information below to register'
              />
            <form onSubmit={onSubmitUser}>
              <FormInput
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder='What is your email?'
                />
              <FormInput
                autoFocus
                value={userName}
                onChange={e => setUserName(e.target.value)}
                placeholder="Username"
                />
              <FormInput
                value={password1}
                onChange={e => setPassword1(e.target.value)}
                placeholder="Password"
                />
              <FormInput
                value={password2}
                onChange={e => setPassword2(e.target.value)}
                placeholder='Confirm password'
                />
              <div style={{
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                <div
                  style={{
                    width:'600px',
                    padding: '10px',
                    margin: '10px',
                    }}
                  >
                  {(errorEmail !== "")
                    ? <p style={warnStyle}>{errorEmail}</p>
                    : null
                  }
                  {(errorUserName !== "")
                      ? <p style={warnStyle}>{errorUserName}</p>
                      : null
                  }
                  {(errorPassword1 !== "")
                      ? <p style={warnStyle}>{errorPassword1}</p>
                      : null
                  }
                  {(errorPassword2 !== "")
                    ? <p style={warnStyle}>{errorPassword2}</p>
                    : null
                  }
                  {(errorPasswordMatch !== "")
                    ? <p style={warnStyle}>{errorPasswordMatch}</p>
                    : null
                  }
                  {(errorPasswordLength !== "")
                    ? <p style={warnStyle}>{errorPasswordLength}</p>
                    : null
                  }
                </div>
              </div>

              <div
                style={{
                  margin: '30px 0 150px 0',
                  display: 'flex',
                  justifyContent: 'center'}}
                  >
                <ButtonHover
                  buttonName = "Register"
                  pageRef = "/prephysicianform"
                  />
              </div>
            </form>

          </div>
          <div style={{
              width: '7vw',
              height: '84vh'
            }}>
          </div>
        </div>
      </div>
    )
  }

export default PrephysicianRegister
